import type { Node } from '@xyflow/react';

export type SavedLayout = Record<string, { x: number; y: number }>;

/**
 * Apply a persisted manual layout (A4) to freshly-built graph nodes. Nodes with
 * a saved position are pinned to it; the rest keep their incoming position. The
 * `hasSaved` flag lets the canvas skip the auto-layout algorithm when the user
 * has a saved arrangement (otherwise it would clobber the restored positions).
 */
export function applySavedLayout(
  nodes: Node[],
  saved: SavedLayout | null | undefined
): { nodes: Node[]; hasSaved: boolean } {
  const map = saved ?? {};
  let hasSaved = false;
  const out = nodes.map((n) => {
    const p = map[n.id];
    if (p && typeof p.x === 'number' && typeof p.y === 'number') {
      hasSaved = true;
      return { ...n, position: { x: p.x, y: p.y } };
    }
    return n;
  });
  return { nodes: out, hasSaved };
}

/** Collect the current node positions into a { id: {x,y} } map for persistence. */
export function collectLayout(nodes: Node[]): SavedLayout {
  const out: SavedLayout = {};
  for (const n of nodes) out[n.id] = { x: n.position.x, y: n.position.y };
  return out;
}
